import api from '../../api/index';
import config from '../../../static/config.json';

const state = {}
const mutations = {}
const getters = {}
const actions = {
    // 通过展会id获取直播信息
    getRoomByExId({
        rootState,
        commit
    }, opt) { // 获取专业买家 展会id 
        return new Promise((resolve, reject) => {
            api.get(`${config.https.api}/api/v1/liveroom/exhibition/short/todate?exhibitionId=${opt.exhibitionId}&userId=${opt.userId}`, rootState.header).then(data => {
                if (data.data) {  
                    resolve(data.data.data); 
                } else {
                    resolve(false);
                }
            }).catch((err) => {
                resolve(false);
                console.log(err);
            });
        });
    }, 
    // 通过roomId获取直播播流
    getLiveUrl({
        rootState,
        commit
    }, id) { // 获取专业买家 展会id
        return new Promise((resolve, reject) => {
            api.get(`${config.https.api}/api/v1/liveroom/pull?roomId=${id}`, rootState.header).then(data => {
                if (data.data) { 
                    commit('setLivetUrl', data.data[2], { root: true });
                    resolve(data.data[2]);
                } else {
                    resolve(false);
                }
            }).catch((err) => {
                resolve(false);
                console.log(err);
            });
        });
    }, 
    //通过roomId获取前20条留言
    getBarrage({
        rootState,
        commit
    },id){
        return new Promise((resolve,reject)=>{
            api.get(`${config.https.api}/api/v1/livecomment/top?roomId=${id}&topNum=20`, rootState.header)
            .then(data=>{
                if(data&&data.data.length){
                    resolve(data.data);
                }else{
                    resolve(false);
                }
            }).catch((err) => {
                resolve(false);
                console.log(err);
            });
        })
    },
    getRoomByLang({
        rootState,
        commit
      }, id) { // 直播同声地址
        return new Promise((resolve, reject) => {
            api.get(`${config.https.api}/api/v1/liveroom/live-url/by?roomId=${id}`,  rootState.header).then(({
            data
          }) => {
            if (data) {
              resolve(data);
            } else {
              resolve(false);
            }
          }).catch((err) => {
            resolve(false);
            console.log(err);
          });
        });
    },
  
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}